export default {
	DONATE_ADDRESS: 'nano_3jmjgk57hbtfkzoao4etwfizsup5xeqkemhsnp564ttr7iuzoxjdx7rfw5gh',
};
